











import { Component, Vue, Emit } from 'vue-property-decorator';
import { Datasource } from '../services/datasource';
import { setTimeout } from 'timers';

@Component
export default class UploadMachines extends Vue {
  isUploading:boolean = false

  source:Datasource

  constructor() {
    super()
    this.source = Datasource.shared
  }

  @Emit()
  uploadStarted() {
    if (!this.$refs.file || !(this.$refs.file as any).files) {
      return
    }
    console.log('Upload started')
    this.isUploading = true

    this.source.uploadMachines(this.$refs.file && (this.$refs.file as any).files[0])
      .then((records_processed:number) => {
        console.log('Upload done', records_processed, 'records processed.')
        this.uploadCompleted()
      })
      .catch(console.error)
  }

  @Emit()
  uploadCompleted() {
    // reset file
    (this.$refs.file as any).value = ""
    setTimeout(() => {
      this.isUploading = false
      console.log('Upload completed')
    }, 2100)
  }
}
